<template>
	<el-submenu :class="data, $route, activeIndex | supClass" :index="data.url">
		<template slot="title">
			<span class="active-color"></span>
			<i :class="data.iconClass" />
			<span>
				{{ data.name }}
				<!-- <span v-if="data.name === '提现审核' && (tipNum.widthdrawl > 0 || tipNum.staffWidthdrawl > 0)"
					class="red-dot"></span>
				<span v-if="data.name === '酒店商城管理' && tipNum.order > 0" class="red-dot"></span>
				<span v-if="data.name === '小程序内容配置' && tipNum.merchant > 0" class="red-dot"></span> -->
			</span>
		</template>
		<el-menu-item :index="child.url" :key="child.url" v-for="child in data.children">
			<i :class="child,$route.meta | transIcon" />
			<span slot="title" :class="{active: child.url === activeIndex}">
				{{ child.name }}
				<!-- <span v-if="child.name === '酒店提现审核' && tipNum.widthdrawl > 0" class="badge">{{tipNum.widthdrawl}}</span>
				<span v-if="child.name === '员工提现审核' && tipNum.staffWidthdrawl > 0"
					class="badge">{{tipNum.staffWidthdrawl}}</span>
				<span v-if="child.name === '订单管理' && tipNum.order > 0" class="badge">{{tipNum.order}}</span>
				<span v-if="child.name === '商家入驻手机' && tipNum.merchant > 0" class="badge">{{tipNum.merchant}}</span> -->
			</span>
		</el-menu-item>
	</el-submenu>
</template>

<script>
	import MenuItem from "./menu-item";
	import {
		mapState
	} from "vuex";

	export default {
		name: "SubMenu",
		filters: {
			transIcon({
				route,
				iconClass
			}, routeMeta) {
				// return routeMeta[0].url + routeMeta[1].url === route ? `${iconClass}-active` : iconClass
			},
			supClass(routeObj, $route, activeIndex) {
				const menuRoute = routeObj.route;
				if (routeObj.children) {
					const childRoutes = routeObj.children.map(item => item.route);
					const childActive = childRoutes.some(item => {
						return $route.path.includes(item) || item === activeIndex;
					});
					return childActive ? "sup-active" : "";
				}
				return $route.path === menuRoute ? "sup-active" : "";
			}
		},
		props: {
			data: {
				type: Object,
				default () {
					return {};
				}
			}
		},
		data() {
			return {
				activeIndex: ""
			};
		},
		computed: {
			...mapState(["tipNum"])
		},
		mounted() {
			this.activeIndex = this.$route.meta[
				this.$route.meta.length - 1
			].activeRoute;
		},
		watch: {
			$route(val) {
				this.activeIndex = val.meta[val.meta.length - 1].activeRoute;
			}
		},
		components: {
			MenuItem
		}
	};
</script>

<style scoped>
	.active {
		color: #1890ff;
	}

	.sup-active .active-color {
		display: inline-block;
		position: relative;
		left: -10px;
		width: 3px;
		height: 22px;
		background: #1890ff;
	}

	.badge {
		position: relative;
		bottom: 17px;
		right: 10px;
		background-color: #f56c6c;
		border-radius: 10px;
		color: #fff;
		display: inline-block;
		font-size: 12px;
		height: 18px;
		line-height: 18px;
		padding: 0 6px;
		text-align: center;
		white-space: nowrap;
		border: 1px solid #fff;
	}

	.red-dot {
		position: relative;
		bottom: 12px;
		right: 5px;
		display: inline-block;
		width: 10px;
		height: 10px;
		border-radius: 50%;
		background-color: #f56c6c;
	}
</style>